import type { ImageAnalysis } from '../../types/visual.types';

interface Props {
  analyses: ImageAnalysis[];
  interpretation: string;
}

export default function VisualAnalysisCard({ analyses, interpretation }: Props) {
  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
      <h3 className="text-sm font-medium text-blue-900 mb-2">Visual Analysis</h3>

      {/* Combined Interpretation */}
      <p className="text-sm text-blue-800 mb-4">{interpretation}</p>

      {/* Individual Image Analyses */}
      <div className="space-y-3">
        {analyses.map((analysis, index) => (
          <div key={index} className="bg-white rounded-md p-3">
            <div className="flex items-center gap-2 mb-2">
              <span className="text-xs font-semibold text-gray-600">Image {index + 1}</span>
              <span className="text-xs text-gray-500">
                {(analysis.confidence * 100).toFixed(0)}% confidence
              </span>
            </div>

            <div className="flex flex-wrap gap-1 mb-2">
              {analysis.mood_descriptors.map((mood, i) => (
                <span key={i} className="px-2 py-1 bg-purple-100 text-purple-700 text-xs rounded">
                  {mood}
                </span>
              ))}
            </div>

            <p className="text-xs text-gray-600">
              {analysis.atmosphere} • {analysis.emotion}
            </p>

            {(analysis.location_context || analysis.cultural_context) && (
              <p className="text-xs text-gray-500 mt-1">
                {[analysis.location_context, analysis.cultural_context]
                  .filter(Boolean)
                  .join(' • ')}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
